import { render } from "./App.vue?vue&type=template&id=ad34d5c0&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=ad34d5c0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=ad34d5c0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad34d5c0"]])

export default __exports__